export const setProcesses = (state, response) => {
    state.processesList = response;
};

export const setProcessInspectorById = (state, data) => {
    state.processInspectorById = data.data;
};
